import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { pathToClass } from "./classes";
import { ClassPage } from "./pages/ClassPage";
import { Methodology } from "./pages/Methodology";
import { InsiderTrades } from "./pages/InsiderTrades";
import { Leagues } from "./pages/Leagues";
import { Onboarding } from "./pages/Onboarding";
import { destinations, SiteShell } from "./components/SiteShell";
import { metaFor, SITE } from "./route-meta";
import "./terminal.css";
import "./redesign.css";

// Keep old bookmarks working while every original tool lives under Tokenization.
// The root opens Tokenization (U-18: no landing page). The Worker already
// redirects "/" (public/_redirects); this covers the dev server and keeps any
// query or fragment. replaceState adds no history entry, so Back cannot loop.
let path = location.pathname.replace(/\/+$/, "");
const legacyPaths = ["/stablecoins", "/treasuries", "/govt-debt", "/credit", "/methodology"];
if (!path || legacyPaths.includes(path)) {
  path = `/tokenization${path}`;
  history.replaceState(null, "", `${path}${location.search}${location.hash}`);
}
// Research opens its first tool, as the root opens Tokenization.
if (path === "/research") {
  path = "/research/insider-trades";
  history.replaceState(null, "", `${path}${location.search}${location.hash}`);
}
const assetClass = pathToClass(path);
const methodology = path === "/tokenization/methodology";
const onboarding = path === "/tokenization/onboarding";
const leagues = path === "/tokenization/leagues";
const insider = path === "/research/insider-trades";
const destination = destinations.find(item => item.path === path);
const section = insider ? "Research" : destination?.label ?? "Tokenization";
const blank = !!destination && destination.path !== "/tokenization";
const known = !!destination || !!assetClass || methodology || onboarding || leagues || insider;
const content = blank ? <main aria-label={section} />
  : insider ? <InsiderTrades />
  : methodology ? <Methodology />
  : onboarding ? <Onboarding />
  : leagues ? <Leagues />
  : assetClass && assetClass !== "stocks" ? <ClassPage classId={assetClass} />
  : <App />;
const page = (
  <SiteShell section={section}>
    {known ? content : <main className="editorial-panel"><h2>Page not found</h2><a href="/tokenization">Go to Tokenization →</a></main>}
  </SiteShell>
);
// The build writes these tags into each route's HTML (route-meta.ts); this covers
// legacy paths rewritten above and the dev server.
const meta = metaFor(path);
document.title = meta?.title ?? `${section} — Panther Terminal`;
const canonical = `${SITE}${path}`;
document.querySelector('link[rel="canonical"]')?.setAttribute("href", canonical);
document.querySelector('meta[property="og:url"]')?.setAttribute("content", canonical);
document.querySelector('meta[property="og:title"]')?.setAttribute("content", document.title);
document.querySelector('meta[name="twitter:title"]')?.setAttribute("content", document.title);
if (meta) {
  document.querySelector('meta[name="description"]')?.setAttribute("content", meta.description);
  document.querySelector('meta[property="og:description"]')?.setAttribute("content", meta.description);
  document.querySelector('meta[name="twitter:description"]')?.setAttribute("content", meta.description);
}
createRoot(document.getElementById("root")!).render(<StrictMode>{page}</StrictMode>);
